/**
 * UserPosMarker
 */

import React from 'react';

class UserPosMarker extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        const size = 17;
        const markerStyle = {
            position: 'absolute',
            width: size,
            height: size,
            left: -size / 2,
            top: -size / 2
        }

        return (
            <div
                className="UserPosMarker"
                style={markerStyle}
            />
        );
    }
}

UserPosMarker.defaultProps = {
};

export default UserPosMarker;
